import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  input
} from '@angular/core';
import {SortDirection, TableSort} from '../shared/classes/TableSort';

const rotateMap = new Map();

/**
 * This directive allows to sort table headers.
 */
@Directive({
  selector: 'span[appSortable]',
})
export class NgbdSortableHeaderDirective implements OnInit {

  /**
   * An identifier for a header/column name.
   */
          // eslint-disable-next-line @angular-eslint/no-input-rename
  readonly headerName = input<string>(undefined, {alias: "appSortable"});
  /**
   * Sort direction.
   */
  @Input() direction: SortDirection = SortDirection.NONE;
  /**
   * Output of which header/column to which direction should be sorted.
   */
  @Output() sort = new EventEmitter<TableSort>();

  @HostBinding('class') class = 'sortable-header';

  /**
   * Sorts a header/column to the next direction.
   */
  @HostListener('click') onClick() {
    this.direction = rotateMap.get(this.direction);
    this.class = 'sortable-header ' + this.direction;
    const tableSort = new TableSort(this.headerName(), this.direction);
    this.sort.emit(tableSort);
  }

  /**
   * Defines the order of sort direction.
   */
  ngOnInit(): void {
    rotateMap.set(SortDirection.ASC, SortDirection.DESC);
    rotateMap.set(SortDirection.DESC, SortDirection.NONE);
    rotateMap.set(SortDirection.NONE, SortDirection.ASC);
  }

  /**
   * Resets sort direction of headers who are not selected.
   * @param tableSort an object containing table header and its direction
   * @param ngbdHeaders list of multiple header directives
   */
  reset(tableSort: TableSort, ngbdHeaders: QueryList<NgbdSortableHeaderDirective>) {
    ngbdHeaders.forEach(header => {
      if (header.headerName() !== tableSort.column) {
        header.direction = SortDirection.NONE;
        header.class = 'sortable-header';
      }
    });
  }
}
